<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ödeme Miktarı</label>
            <v-currency-input input-class="text-right currency-font-size" :value="value.Tutar" v-on:updateValue="v => value.Tutar = v"></v-currency-input>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" v-model="value.Description" placeholder="Açıklama"></textarea>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.CanInstallment">Taksit Yapılabilir</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    props:{
        value:Object
    },
    components: { 
        VCurrencyInput,
        BFormCheckbox 
    },
}
</script>

<style>

</style>